import IndexView from '@/components/templates/IndexView.vue'
import MemberView from '@/components/templates/MemberView.vue'
import WorkView from "@/components/templates/WorkView"
import AccessView from "@/components/templates/AccessView";

export default [
    {
        path: '/',
        component: IndexView
    },
    {
        path: '/Member',
        component: MemberView
    },
    {
        path: '/Work',
        component: WorkView
    },
    {
        path: '/Access',
        component: AccessView
    },
    {
        path: '*',
        redirect: '/',
    }
]
